import { ApiResult, appendToFormData, urlMaker, caller } from '@shared/utils';
import { DeclarationMappers } from '../mappers';
import { DeclarationProformaInvoice } from '../types/proforma-invoice';
import { translate } from '@infra/i18n/i18n';
import { DeclarationsProformaInvoiceMappers } from '../mappers/proforma-invoice';
import { IProformDetails, ProformEditFormDataPersistence } from '../types/edit-proform';

export class DeclarationsProformaInvoiceService {
  public static async getOneById(
    ids: (string | number)[],
  ): Promise<ApiResult<200, DeclarationProformaInvoice> | ApiResult<422, string[]> | ApiResult<400 | 500, string>> {
    const url = urlMaker('/api/warehouse/declaration/proforma', { declaration_id: ids });

    try {
      const response = await caller(url);

      if (response.ok) {
        const data = await response.json();
        const mappedData = DeclarationMappers.ProformaInvoice.oneFromApi(data);

        return new ApiResult(200, mappedData, null);
      } else if (response.status === 422) {
        const { errors } = await response.json();
        const mappedErrors = DeclarationMappers.ProformaInvoice.errorsFromApi(errors);
        return new ApiResult(422, mappedErrors, null);
      } else {
        return new ApiResult(400, translate('common.errors.operationFailed'), null);
      }
    } catch (e) {
      return new ApiResult(500, translate('common.errors.networkFailed'), null);
    }
  }

  public static async getDetailedById(
    id: string | number,
  ): Promise<ApiResult<200, IProformDetails> | ApiResult<422, string[]> | ApiResult<400 | 500, string>> {
    const url = urlMaker(`/api/warehouse/proforma/${id}`);

    try {
      const response = await caller(url);

      if (response.ok) {
        const data = await response.json();
        const result = DeclarationsProformaInvoiceMappers.detailsToDomain(data);
        return new ApiResult(200, result, null);
      } else if (response.status === 422) {
        const { errors } = await response.json();
        const mappedErrors = DeclarationMappers.ProformaInvoice.errorsFromApi(errors);
        return new ApiResult(422, mappedErrors, null);
      } else {
        return new ApiResult(400, translate('common.errors.operationFailed'), null);
      }
    } catch (e) {
      return new ApiResult(500, translate('common.errors.networkFailed'), null);
    }
  }

  public static async createProduct(
    body: ProformEditFormDataPersistence,
  ): Promise<ApiResult<200, boolean> | ApiResult<422, string[]> | ApiResult<400 | 500, string>> {
    const url = urlMaker(`/api/warehouse/proforma`);
    const formData = new FormData();
    appendToFormData(body, formData);
    try {
      const response = await caller(url, { method: 'post', body: formData });
      if (response.ok) {
        return new ApiResult(200, true, null);
      } else if (response.status === 422) {
        const { errors } = await response.json();
        const mappedErrors = DeclarationMappers.ProformaInvoice.errorsFromApi(errors);
        return new ApiResult(422, mappedErrors, null);
      } else {
        return new ApiResult(400, translate('common.errors.operationFailed'), null);
      }
    } catch (e) {
      return new ApiResult(500, translate('common.errors.networkFailed'), null);
    }
  }

  public static async removeProduct(id: string | number): Promise<ApiResult<200, boolean> | ApiResult<422, string> | ApiResult<400 | 500, string>> {
    const url = urlMaker(`/api/warehouse/proforma/${id}`);
    try {
      const response = await caller(url, { method: 'delete' });
      if (response.ok) {
        return new ApiResult(200, true, null);
      } else {
        return new ApiResult(400, translate('common.errors.operationFailed'), null);
      }
    } catch (e) {
      return new ApiResult(500, translate('common.errors.networkFailed'), null);
    }
  }
}
